const base = 'AskAnythingMetrics';

export const queryKeys = {
  askedQuesCount: `${base}/AskedQuestionCount`,
  routedQuesCount: `${base}/RoutedQuestionCount`,
  responsesReceivedCount: `${base}/ResponsesReceivedCount`,
};